export const HR_JOB_TITLE_PERMISSION_CODES = {
    WEB_HR_JOB_TITLE_LIST: 'WEB_HR_JOB_TITLE_LIST',
    WEB_HR_JOB_TITLE_DETAIL: 'WEB_HR_JOB_TITLE_DETAIL',
    WEB_HR_JOB_TITLE_ADD: 'WEB_HR_JOB_TITLE_ADD',
    WEB_HR_JOB_TITLE_EDIT: 'WEB_HR_JOB_TITLE_EDIT',
    WEB_HR_JOB_TITLE_DELETE: 'WEB_HR_JOB_TITLE_DELETE',
    WEB_HR_JOB_TITLE_IMPORT: 'WEB_HR_JOB_TITLE_IMPORT',
    WEB_HR_JOB_TITLE_EXPORT: 'WEB_HR_JOB_TITLE_EXPORT',
} as const;

